export const getSearch = state => state.searchBar
export const getSearchBarText = state => state.searchBar.searchText
export const getSearchBarStatus = state => state.searchBar.status
